import { Component, OnInit, Optional } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { StringHelper } from '../../../core/helpers/strings.helper';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { TerminalService } from '../../../core/services/terminal.service';
import { UtilityService } from '../../../core/services/utility.service';
import { AGENCY_FEATURES_NAMES, DEFAULT_FEATURES_NAMES, GENERAL_FEATURES_NAMES, HIDE_FEATURES_NAMES, MERCHANT_FEATURES_NAMES, MONNIFY_FEATURES_NAMES } from '../../../shared/constants';
import { StorageKeys } from '../../../shared/models/storage-keys';
import { ModalOptionsConfig, ModalService } from '../nz-modal-service/modal.service';

@Component({
	selector: 'app-pos-config-features',
	templateUrl: './pos-config-features.component.html',
	styleUrls: ['./pos-config-features.component.scss']
})
export class PosConfigFeaturesComponent implements OnInit {

	posTerminalFeatures: any[] = [];
	terminalFeaturesByGroup = {
		agency: [],
		merchant: [],
		general: [],
		monnify: [],
		default: []
	};
	loading = false;
	submitting: boolean;
	errorMessage: any;
	submittingForm = false;
	readonly base64ImagePrefix = 'data:image/png;base64,';
	constants = DEFAULT_FEATURES_NAMES;
	selectedFeature: any;
	runningModal: NzModalRef;

	constructor(@Optional() public modalRef: NzModalRef, private localStorage: LocalStorageService,
		public modalService: ModalService,
		public domSanitizer: DomSanitizer,
		private utilityService: UtilityService, private terminalService: TerminalService) {
		this.getPOSBusinessFeatures();
	}

	ngOnInit(): void {
	}

	getPOSBusinessFeatures() {
		this.loading = true;
		this.resetData();
		this.terminalService.getBusinessTerminalFeatures().then(res => {
			this.posTerminalFeatures = res;
			this.posTerminalFeatures.forEach((feature: any) => {
				feature.status = feature.status == 'DISABLED' ? false : true;
				feature.name = feature.name.replace('_', ' ');
				this.groupFeature(feature);
			});
			this.loading = false;
		}).catch(error => {
			this.loading = false;
			this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(error);
		});
	}

	groupFeature(feature) {
		if (feature.name.toLocaleLowerCase() == HIDE_FEATURES_NAMES.INWARD_TRANSFER.toLocaleLowerCase() || feature.name.toLocaleLowerCase() == HIDE_FEATURES_NAMES.DEPOSITS.toLocaleLowerCase()) {
			feature.status = false;
			return;
		}
		/*  if (AGENCY_FEATURES_NAMES.includes(feature.name.toLocaleLowerCase())) {
		   feature['type'] = 'AGENCY';
		   this.terminalFeaturesByGroup.agency.push(feature);
		 } else if (MERCHANT_FEATURES_NAMES.includes(feature.name.toLocaleLowerCase())) {
		   feature['type'] = 'MERCHANT';
		   this.terminalFeaturesByGroup.merchant.push(feature);
		 }
		 else if (GENERAL_FEATURES_NAMES.includes(feature.name.toLocaleLowerCase())) {
		   feature['type'] = 'GENERAL';
		   this.terminalFeaturesByGroup.general.push(feature);
		 } */
		if (MONNIFY_FEATURES_NAMES.includes(feature.name.toLocaleLowerCase())) {
			feature['type'] = 'MONIIFY';
			this.terminalFeaturesByGroup.monnify.push(feature);
		} else {
			feature['type'] = 'DEFAULT';
			this.terminalFeaturesByGroup.default.push(feature);
		}
	}


	submitForm() {
		if (this.isDisabled()) {
			return;
		}
		this.applyPosFeatures();
	}

	isDisabled(): boolean {
		return !this.posTerminalFeatures.find((item) => item.status == true);
	}

	close(value?) {
		this.utilityService.destroyPOSConfigFeaturesModal(value);
		this.modalRef.close();
	}

	identify(index, item) {
		return item.id;
	}

	applyPosFeatures() {
		this.submittingForm = true;
		let selectedFeatures = this.posTerminalFeatures.filter((feature) => feature.status == true).map((feature) => feature.id);
		let payload = {
			"businessId": this.localStorage.get(StorageKeys.businessId),
			"moniepointFeaturesId": selectedFeatures
		}
		this.terminalService.applyBusinessTerminalFeatures(payload).then(res => {
			this.submittingForm = false;
			this.localStorage.save(StorageKeys.is_categorized_terminal, true)
			this.close(true);
		}).catch(error => {
			this.submittingForm = false;
			this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(error);
		});
	}

	showIcon(name: string) {
		return name.toLocaleLowerCase() == this.constants.COLLECTION.toLocaleLowerCase() || name.toLocaleLowerCase() == this.constants.PAYCODE.toLocaleLowerCase();
	}

	hideFeature(name: string) {
		return name.toLocaleLowerCase() == HIDE_FEATURES_NAMES.INWARD_TRANSFER.toLocaleLowerCase();
	}

	onChangeFeature(event, val) {
		/* if (val.name.toLocaleLowerCase() == 'purchase' || val.name.toLocaleLowerCase() == 'withdrawal') {
		  let indexPurchase = this.terminalFeaturesByGroup.merchant.findIndex(item => item.name.toLocaleLowerCase() == 'purchase');
		  let indexWithdrawal = this.terminalFeaturesByGroup.agency.findIndex(item => item.name.toLocaleLowerCase() == 'withdrawal');
		  if (indexPurchase != -1) {
			this.terminalFeaturesByGroup.merchant[indexPurchase].clickable = false;
		  }
		  if (indexWithdrawal != -1) {
			this.terminalFeaturesByGroup.agency[indexWithdrawal].clickable = false;
		  }
		} */
		this.selectedFeature = val;
	}

	alertModal(message: string) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = 'new_confirm';
		config.nzComponentParams.title = 'Are you sure you want to enable?';
		config.nzWidth = 396;
		config.nzComponentParams.message = message;
		config.nzComponentParams.callback = (result) => {
			this.onProceed(result);
		};
		this.runningModal = this.modalService.alert(config);
	}

	onProceed(result) {
		this.runningModal?.close(true);
		this.modalRef?.close(true);
		if (this.selectedFeature.name.toLocaleLowerCase() == 'purchase') {
			let index = this.posTerminalFeatures.findIndex(item => item.name.toLocaleLowerCase() == 'withdrawal');
			if (index != -1) {
				this.posTerminalFeatures[index].status = false;
			}
		}
		if (this.selectedFeature.name.toLocaleLowerCase() == 'withdrawal') {
			let index = this.posTerminalFeatures.findIndex(item => item.name.toLocaleLowerCase() == 'purchase');
			if (index != -1) {
				this.posTerminalFeatures[index].status = false;
			}
		}

	}
	resetData() {
		this.posTerminalFeatures = [];
		this.terminalFeaturesByGroup.agency = [];
		this.terminalFeaturesByGroup.merchant = [];
		this.terminalFeaturesByGroup.general = [];
		this.terminalFeaturesByGroup.monnify = [];
		this.terminalFeaturesByGroup.default = [];
	}

}
